module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('bar-top'), _vm._v(" "), _c('alert-handler', {
    ref: "alert"
  }), _vm._v(" "), _c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "col-md-2 offset-md-1"
  }, [_c('h2', [_vm._v(_vm._s(_vm.detailTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-3"
  }, [(_vm.isReadOnly && _vm.privUser) ? _c('b-button', {
    attrs: {
      "variant": "default",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: _vm.detailRouterUrl,
          params: {
            id: _vm.rec.id
          },
          query: {
            mode: 'edit'
          }
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Edit\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('b-button', {
    attrs: {
      "variant": "default",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: _vm.detailRouterUrl,
          params: {
            id: _vm.rec.id
          }
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo"
  }), _vm._v(" Undo Edit\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isEdit && !(_vm.tableCfg.disableDelete && _vm.tableCfg.disableDelete(_vm.rec)) && _vm.privUser) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalDeleteOk",
      modifiers: {
        "modalDeleteOk": true
      }
    }],
    attrs: {
      "variant": "default",
      "size": "sm"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isReadOnly) ? _c('b-button', {
    attrs: {
      "variant": "default",
      "size": "sm",
      "disabled": _vm.isSaveDisabled
    },
    on: {
      "click": function($event) {
        _vm.submitRecord()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save\n        ")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "default",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.backToOverview()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" Overview\n        ")]), _vm._v(" "), _vm._t("ExtraOptions", null, {
    rec: _vm.rec
  })], 2)]), _vm._v(" "), _c('div', [_vm._t("FormLayout", [_vm._v("\n      Here is the form\n    ")], {
    rec: _vm.rec
  })], 2), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modalDeleteOk",
      "title": 'Delete ' + this.deleteTitle,
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": _vm.deleteRecord
    }
  }, [_vm._v("\n    Are you sure you want to delete this " + _vm._s(_vm.deleteTitle) + "?\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03cff656"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DetailLayout.vue
// module id = 690
// module chunks = 1